import React from "react";
import { Button, Grid } from "@mui/material";
import { Field, Form, Formik, FormikProps } from "formik";
import { TextField } from "formik-mui";
import { useTranslation } from "react-i18next";

import { APIError } from "src/types";
import { ScenarioCopyMutationData } from "src/hooks/scenarios";
import { useScenarioCopySchema } from "src/schemas/scenario-copy.schema";
import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";
import { ServerErrors } from "src/components/form-components/ServerErrors";

export type ScenarioFormData = ScenarioCopyMutationData;

interface Props {
  // data: ScenarioFormData;
  onClose: () => void;
  onSubmit: (values: ScenarioFormData) => void;
  isLoading: boolean;
  errors?: APIError[] | null;
  formRef?: React.MutableRefObject<FormikProps<ScenarioFormData> | null>;
}

export function ScenarioCopyForm(props: Props) {
  const { t } = useTranslation();
  const validationSchema = useScenarioCopySchema();

  const initialValues: ScenarioFormData = {
    scenarioName: "",
  };

  return render();

  function render() {
    return (
      <Formik
        innerRef={props.formRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values: ScenarioFormData) => {
          return props.onSubmit(values);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Field component={TextField} name="scenarioName" label={t("label.name")} type="text" fullWidth />
              </Grid>

              {props.errors && (
                <Grid item xs={12}>
                  <ServerErrors data={props.errors} />
                </Grid>
              )}

              <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-end" }}>
                <Button variant="text" onClick={props.onClose}>
                  {t("label.cancel")}
                </Button>
                <ButtonLoading
                  isLoading={isSubmitting || props.isLoading}
                  type="submit"
                  color="primary"
                  variant="contained"
                >
                  {t("label.save")}
                </ButtonLoading>
              </ButtonGrid>
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}
